(ns ui.view.transaction-process.stage-renderer
  (:require
   [re-frame.core :as rf]
   [ui.view.transaction-process.cards.conditions :as conditions]
   [ui.view.transaction-process.cards.declarations :as declarations]
   [ui.view.transaction-process.cards.decisions :as decisions]
   [ui.view.transaction-process.cards.field-card :as field-card]
   [ui.view.transaction-process.cards.placeholder :as placeholder]
   [ui.view.transaction-process.cards.transaction-summary :as transaction-summary]
   [ui.view.transaction-process.cards.transaction-teams :as transaction-teams]
   [ui.view.transaction-process.cards.verifications :as verifications]
   [ui.view.transaction-process.components.detail-panel :as detail-panel]
   [ui.view.transaction-process.event :as event]
   [ui.view.transaction-process.sub :as sub]))

(defn- render-card
  [{:keys [card] :as ctx}]
  (case (:card/type card)
    :field-card         [field-card/view ctx]
    :transaction-teams  [transaction-teams/view ctx]
    :transaction-summary [transaction-summary/view ctx]
    :declarations       [declarations/view ctx]
    :decisions          [decisions/view ctx]
    :verifications      [verifications/view ctx]
    :conditions         [conditions/view ctx]
    [placeholder/view ctx]))

(defn- full-width-view
  [{:keys [stage-config ctx process-id] :as props}]
  (let [cards (:stage/cards stage-config)
        card-ctx (dissoc props :stage-config)]
    [:div {:class "flex min-h-0 flex-1 overflow-hidden"}
     [:div {:class "px-8 py-6 min-h-0 flex-1 overflow-auto"}
      [:div {:class "max-w-3xl mx-auto flex flex-col gap-4"}
       (for [card cards]
         ^{:key (:card/id card)}
         [render-card (assoc card-ctx :card card)])]]
     ;; Cards in a full-width stage open the detail panel too: the declarations
     ;; card routes users without write access here instead of to the editor
     ;; modal. Mounting it only in `three-column-view` left that dispatch
     ;; writing state no view read, so the row looked clickable and nothing
     ;; opened. Renders nil while no panel is open. DEV-8150.
     [detail-panel/view {:ctx        ctx
                         :process-id process-id}]]))

(defn- three-column-view
  [{:keys [stage-config process-id entity-data template ctx current-stage team-assignments]}]
  (let [cards (:stage/cards stage-config)
        left-cards (filter #(= :left (:card/position %)) cards)
        center-cards (filter #(= :center (:card/position %)) cards)
        sidebar-collapsed? @(rf/subscribe [::sub/sidebar-collapsed? ctx])
        card-ctx {:process-id       process-id
                  :entity-data      entity-data
                  :template         template
                  :ctx              ctx
                  :current-stage    current-stage
                  :team-assignments team-assignments}]
    [:div {:class "flex gap-0 min-h-0 flex-1 overflow-hidden"}
     (when (seq left-cards)
       [:div {:class (str "shrink-0 border-r border-gray-200 bg-white relative transition-all duration-200 "
                          (if sidebar-collapsed? "w-0 overflow-hidden" "w-72 overflow-auto p-4"))}
        (for [card left-cards]
          ^{:key (:card/id card)}
          [render-card (assoc card-ctx :card card)])])
     (when (seq left-cards)
       [:button
        {:class    "shrink-0 flex items-center justify-center w-8 bg-gray-50 border-r border-gray-200 text-gray-400 hover:text-gray-600 hover:bg-gray-100 cursor-pointer"
         :on-click #(rf/dispatch [::event/toggle-sidebar ctx])}
        [:svg {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 20 20" :fill "currentColor"
               :class "w-5 h-5"}
         (if sidebar-collapsed?
           [:path {:fill-rule "evenodd" :clip-rule "evenodd"
                   :d "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"}]
           [:path {:fill-rule "evenodd" :clip-rule "evenodd"
                   :d "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"}])]])
     [:div {:class "min-h-0 flex-1 overflow-auto p-6 flex flex-col gap-4"}
      (for [card center-cards]
        ^{:key (:card/id card)}
        [render-card (assoc card-ctx :card card)])]
     [detail-panel/view {:ctx        ctx
                         :process-id process-id}]]))

(defn view
  [props]
  (let [layout (get-in props [:stage-config :stage/layout])]
    (case layout
      :three-column [three-column-view props]
      [full-width-view props])))
